import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/DescriptionList/description-list';
import { css } from '@patternfly/react-styles';
export const DescriptionListGroup = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement("div", Object.assign({ className: css(styles.descriptionListGroup, className) }, props), children));
};
DescriptionListGroup.displayName = 'DescriptionListGroup';
//# sourceMappingURL=DescriptionListGroup.js.map